import theme from 'config/theme';

export default {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
    alignItems: 'center',
    padding: '8px',
    cursor: 'pointer',
    borderRadius: '4px',
    maxWidth: '100%',
    '&:hover': {
      backgroundColor: `${theme.palette.grays?.gray100} !important`,
    },
    '&.Mui-focused': {
      backgroundColor: `${theme.palette.grays?.gray100} !important`,
    },
  },
  name: {
    fontWeight: 600,
    fontSize: '14px',
    color: theme.palette.grays.gray600,
  },
  text: {
    fontSize: '14px',
    color: theme.palette.grays.gray600,
  },
  roleChipOwner: {
    backgroundColor: theme.palette.greens.green200,
    color: theme.palette.grays.gray600,
    border: 'none',
    lineHeight: 1,
  },
  roleChipDriver: {
    backgroundColor: theme.palette.oranges.orange200,
    color: theme.palette.grays.gray600,
    border: 'none',
    lineHeight: 1,
  },
  roleChipAdmin: {
    backgroundColor: theme.palette.blues.blue200,
    color: theme.palette.grays.gray600,
    border: 'none',
    lineHeight: 1,
  },
  activeDriverDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: theme.palette.greens.green400,
    flexShrink: 0,
  },
  inactiveDriverDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: theme.palette.reds.codingRed400,
    flexShrink: 0,
  },
};
